import MRZCRReader, { MRZ_CR_REGEX } from './MRZCRReader'
import MRZMXReader, { MRZ_MX_REGEX } from './MRZMXReader'
import MRZPassportReader, { MRZ_PASSPORT_REGEX } from './MRZPassportReader'

export function normalizeMrz(raw) {
  return String(raw ?? '').toUpperCase().replace(/[^A-Z0-9<]/g, '')
}

export function parseMrz(raw) {
  const code = normalizeMrz(raw)
  if (MRZ_CR_REGEX.test(code)) {
    return { documentType: undefined, data: MRZCRReader(code) }
  }
  if (MRZ_MX_REGEX.test(code)) {
    return { documentType: undefined, data: MRZMXReader(code) }
  }
  if (MRZ_PASSPORT_REGEX.test(code)) {
    return { documentType: 'passport', data: MRZPassportReader(code) }
  }
  return null
}
